import api from "../../utils/api";

// NZSC-3330 — 리포트 적정 매매가/전세가 산정 결과 조회(관리자 열람 전용).
// api-admin: GET /api/v1/report-valuation/admin/reports/:report_seq
//   응답 봉투 { code, message, data: { valuation } } (code === 0 성공).
//   valuation = null 이면 아직 산정 전(report_valuation 행 없음).
//   valuation.payload 는 콜드가 저장한 원문(schemaVersion=1) 그대로다 —
//   고객 응답(api-public)은 화이트리스트 매핑을 거치지만 관리자는 원문을 본다.
// 조회 실패는 리포트 상세 전체를 깨뜨리면 안 되므로 삼키고 ok=false 만 돌려준다.

export const state = {};

export const mutations = {};

export const actions = {
  async acReportValuationDetail(_, { reportSeq }) {
    if (reportSeq === null || reportSeq === undefined || reportSeq === "") {
      return { ok: false, valuation: null };
    }
    const url = `/api/v1/report-valuation/admin/reports/${reportSeq}`;
    try {
      const res = await api.get(url);
      if (res.data?.code === 0) {
        return {
          ok: true,
          valuation: res.data.data?.valuation ?? null,
          // NZSC-3384: 고객 화면 노출 판정(스위치×컷×점수, api-admin 서버 계산).
          // 구버전 API 응답에는 없다 — null 이면 "판정 정보 없음" 표기.
          exposure: res.data.data?.exposure ?? null,
        };
      }
      return { ok: false, valuation: null, exposure: null, message: res.data?.message };
    } catch (error) {
      console.log("acReportValuationDetail error", error?.data || error);
      return { ok: false, valuation: null, exposure: null, message: error?.data?.message };
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
